export const breadcrumb = {
  title: 'SMS-рассылки',

  mailing: {
    index: 'Список рассылок',
    create: 'Создать рассылку'
  },

  message: {
    title: 'Сообщения',
    index: 'Входящие сообщения',
    setting: 'Настройка входящих сообщений',

    tab: {
      index: 'Входящие сообщения',
      setting: 'Настройки'
    }
  },

  template: {
    index: 'Шаблоны'
  },

  sender: {
    index: 'Отправители'
  }
};
